import { render, staticRenderFns } from "./NodeManagement.vue?vue&type=template&id=0ddd3e28&scoped=true&"
import script from "./NodeManagement.vue?vue&type=script&lang=js&"
export * from "./NodeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddd3e28",
  null
  
)

export default component.exports